import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { useState } from 'react';

import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';

import BulkExportSettlementsFailuresDialog, {
  BulkExportSettlementFailureRow,
} from './BulkExportSettlementsFailuresDialog';

interface BulkExportSettlementsFailedToastProps {
  failures: BulkExportSettlementFailureRow[];
  skippedCount: number;
}

// Owns the details dialog so it keeps working after the page that exported unmounts.
export default function BulkExportSettlementsFailedToast({
  failures,
  skippedCount,
}: BulkExportSettlementsFailedToastProps) {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);

  return (
    <>
      <Box sx={{ alignItems: 'center', display: 'flex', gap: 2 }}>
        <Box>
          <Typography variant="body2">
            {t('approvals.driver_pay.settlements.bulk_export_to_accounting.failed', {
              count: failures.length,
            })}
          </Typography>
          {skippedCount > 0 && (
            <Typography variant="caption">
              {t('approvals.driver_pay.settlements.bulk_export_to_accounting.skipped', {
                count: skippedCount,
              })}
            </Typography>
          )}
        </Box>
        <SmallButton
          color="secondary"
          data-test-id="settlement-bulk-export-view-failures-button"
          onClick={() => setIsDetailsOpen(true)}
          variant="outlined"
        >
          {t('approvals.driver_pay.settlements.bulk_export_to_accounting.view_details')}
        </SmallButton>
      </Box>

      <BulkExportSettlementsFailuresDialog
        failures={failures}
        isOpen={isDetailsOpen}
        onClose={() => setIsDetailsOpen(false)}
      />
    </>
  );
}
